// removed by extract-text-webpack-plugin
module.exports = {"app":"app___2TOPA"};


//////////////////
// WEBPACK FOOTER
// ./src/App.module.less
// module id = 749
// module chunks = 0